import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';

function List() {

    const pathFrontEnd = '/synonymsroleslink/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: config.endpoints.backend + 'rolesentityemployees/deletelink',
        endpoint: config.endpoints.backend + 'rolesentityemployees/getall'
    }

    let list = {
        labelTitle: 'Vínculos CBO - Cargos de Entidades',
        labelTitleButtonAdd: 'Vincular',
        fieldsShowOnDelete: ['title'],
        showPrintButtons: true,
        filter: {
            pdc_cbo_synonymous_id: "none"
        },
        columns: [
            {
                name: 'code',
                label: 'Código CBO'
            },
            {
                name: 'title',
                label: 'Sinônimo'
            },
            {
                name: 'role',
                label: 'Cargo'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
